export enum MenuLabel {
  ManageAgents = 'Manage Agents',
  Conversations = 'Conversations',
  KnowledgeManagement = 'Knowledge Management',
  CallManagement = 'Call Management',
  BatchCalls = 'Mass Outreach (Demo)',
  WidgetAnalytics = 'Widget Analytics',
  RoleManagement = 'Role Management',
  OrgManagement = 'Org Management',
  JSONManagement = 'JSON Management',
  ModelsManagement = 'Model Management',
  ConversationsBilling = 'Billing',
  PromptLibrary = 'Prompt Library',
  SipTrunk = 'SIP Trunk',
  SipTrunkVendors = 'SIP Trunk Vendors',
  Logout = 'Logout',
  Login = 'Login',
  Analytics = 'Analytics',
  LiveKitServer = 'LiveKit Server',
}

export const bottomMenuLabels: string[] = [
  MenuLabel.Logout,
  MenuLabel.JSONManagement,
  MenuLabel.RoleManagement,
  MenuLabel.OrgManagement,
  MenuLabel.ModelsManagement,
  MenuLabel.PromptLibrary,
  MenuLabel.SipTrunkVendors,
  MenuLabel.LiveKitServer,
];

export const ROUTE_SEGMENT = {
  AGENTS: 'agents',
  ANALYTICS: 'analytics',
  BATCH_CALLS: 'batch_calls',
  CONVERSATION: 'conversation',
  BILLING: 'billing',
  CALL_MANAGEMENT: 'call_management',
  CALLS_MANAGEMENT: 'calls_management',
  JSON_MANAGEMENT: 'json_management',
  KNOWLEDGE_MANAGEMENT: 'knowledge_management',
  LIVEKIT_SERVER: 'livekit_server',
  MODELS_MANAGEMENT: 'models_management',
  NEW: 'new',
  ORG_MANAGEMENT: 'org_management',
  ORGANIZATION: 'organization',
  PROMPT_LIBRARY: 'prompt_library',
  ROLE_MANAGEMENT: 'role_management',
  SIP_TRUNK: 'sip_trunk',
  SIP_TRUNK_VENDORS: 'sip_trunk_vendors',
  TASK_WIZARD: 'task_wizard',
} as const;

export const ROUTE_PARAM = {
  ORGANIZATION_ID: 'organization_id',
  AGENT_ID: 'agent_id',
  CONVERSATION_ID: 'conversation_id',
} as const;

export const ROUTE_QUERY_PARAM = {
  USER_ID: 'user_id',
  USER_PHONE: 'user_phone',
} as const;

export const ORG_ID_ROUTE_TOKEN = `:${ROUTE_PARAM.ORGANIZATION_ID}`;

export const ROUTE_PATH = {
  ANALYTICS: '/analytics',
  AGENTS: `/${ROUTE_SEGMENT.AGENTS}`,
  BATCH_CALLS: `/${ROUTE_SEGMENT.BATCH_CALLS}`,
  CONVERSATION: `/${ROUTE_SEGMENT.CONVERSATION}`,
  BILLING: `/${ROUTE_SEGMENT.BILLING}`,
  CALL_MANAGEMENT: `/${ROUTE_SEGMENT.CALL_MANAGEMENT}`,
  CALLS_MANAGEMENT: `/${ROUTE_SEGMENT.CALLS_MANAGEMENT}`,
  JSON_MANAGEMENT: `/${ROUTE_SEGMENT.JSON_MANAGEMENT}`,
  KNOWLEDGE_MANAGEMENT: `/${ROUTE_SEGMENT.KNOWLEDGE_MANAGEMENT}`,
  LIVEKIT_SERVER: `/${ROUTE_SEGMENT.LIVEKIT_SERVER}`,
  MODELS_MANAGEMENT: `/${ROUTE_SEGMENT.MODELS_MANAGEMENT}`,
  ORG_MANAGEMENT: `/${ROUTE_SEGMENT.ORG_MANAGEMENT}`,
  PROMPT_LIBRARY: `/${ROUTE_SEGMENT.PROMPT_LIBRARY}`,
  ROLE_MANAGEMENT: `/${ROUTE_SEGMENT.ROLE_MANAGEMENT}`,
  SIP_TRUNK: `/${ROUTE_SEGMENT.SIP_TRUNK}`,
  SIP_TRUNK_VENDORS: `/${ROUTE_SEGMENT.SIP_TRUNK_VENDORS}`,
  NOT_FOUND: '/404',
} as const;

const routeParam = (name: string) => `:${name}`;

export const ROUTE_PATTERN = {
  analytics: {
    list: `${ROUTE_PATH.ANALYTICS}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
  },
  agents: {
    list: `${ROUTE_PATH.AGENTS}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
    new: `${ROUTE_PATH.AGENTS}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${ROUTE_SEGMENT.NEW}`,
    detail: `${ROUTE_PATH.AGENTS}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${routeParam(ROUTE_PARAM.AGENT_ID)}`,
  },
  conversation: {
    list: `${ROUTE_PATH.CONVERSATION}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
    detail: `${ROUTE_PATH.CONVERSATION}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${routeParam(ROUTE_PARAM.CONVERSATION_ID)}`,
  },
  billing: {
    list: `${ROUTE_PATH.BILLING}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
    agent: `${ROUTE_PATH.BILLING}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${routeParam(ROUTE_PARAM.AGENT_ID)}`,
    conversationDetail: `${ROUTE_PATH.BILLING}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${routeParam(ROUTE_PARAM.AGENT_ID)}/${ROUTE_SEGMENT.CONVERSATION}/${routeParam(ROUTE_PARAM.CONVERSATION_ID)}`,
  },
  knowledgeManagement: {
    list: `${ROUTE_PATH.KNOWLEDGE_MANAGEMENT}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
    detail: `${ROUTE_PATH.KNOWLEDGE_MANAGEMENT}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${routeParam('id')}`,
  },
  orgManagement: {
    list: `${ROUTE_PATH.ORG_MANAGEMENT}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
    organization: `${ROUTE_PATH.ORG_MANAGEMENT}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${ROUTE_SEGMENT.ORGANIZATION}/${routeParam('id')}`,
  },
  callManagement: {
    page: `${ROUTE_PATH.CALL_MANAGEMENT}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
  },
  roleManagement: {
    page: `${ROUTE_PATH.ROLE_MANAGEMENT}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
  },
  jsonManagement: {
    page: `${ROUTE_PATH.JSON_MANAGEMENT}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
  },
  modelsManagement: {
    page: `${ROUTE_PATH.MODELS_MANAGEMENT}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
  },
  sipTrunk: {
    page: `${ROUTE_PATH.SIP_TRUNK}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
  },
  promptLibrary: {
    page: `${ROUTE_PATH.PROMPT_LIBRARY}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
  },
  sipTrunkVendors: {
    page: `${ROUTE_PATH.SIP_TRUNK_VENDORS}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
  },
  livekitServer: {
    page: `${ROUTE_PATH.LIVEKIT_SERVER}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
  },
  batchCalls: {
    list: `${ROUTE_PATH.BATCH_CALLS}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
    wizard: `${ROUTE_PATH.BATCH_CALLS}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${ROUTE_SEGMENT.TASK_WIZARD}`,
    wizardDetail: `${ROUTE_PATH.BATCH_CALLS}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${ROUTE_SEGMENT.TASK_WIZARD}/${routeParam('task_id')}`,
  },
  callsManagement: {
    detail: `${ROUTE_PATH.CALLS_MANAGEMENT}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${routeParam('task_id')}`,
  },
} as const;

export const ORG_SCOPED_ROUTE_PREFIXES = [
  ROUTE_SEGMENT.ANALYTICS,
  ROUTE_SEGMENT.AGENTS,
  ROUTE_SEGMENT.BATCH_CALLS,
  ROUTE_SEGMENT.CONVERSATION,
  ROUTE_SEGMENT.BILLING,
  ROUTE_SEGMENT.CALL_MANAGEMENT,
  ROUTE_SEGMENT.CALLS_MANAGEMENT,
  ROUTE_SEGMENT.JSON_MANAGEMENT,
  ROUTE_SEGMENT.KNOWLEDGE_MANAGEMENT,
  ROUTE_SEGMENT.LIVEKIT_SERVER,
  ROUTE_SEGMENT.MODELS_MANAGEMENT,
  ROUTE_SEGMENT.ORG_MANAGEMENT,
  ROUTE_SEGMENT.PROMPT_LIBRARY,
  ROUTE_SEGMENT.ROLE_MANAGEMENT,
  ROUTE_SEGMENT.SIP_TRUNK,
  ROUTE_SEGMENT.SIP_TRUNK_VENDORS,
] as const;

export type OrgScopedRoutePrefix = (typeof ORG_SCOPED_ROUTE_PREFIXES)[number];
